import { render, staticRenderFns } from "./ShipToDropdown.vue?vue&type=template&id=4b63cd4e&scoped=true"
import script from "./ShipToDropdown.vue?vue&type=script&lang=js"
export * from "./ShipToDropdown.vue?vue&type=script&lang=js"
import style0 from "./ShipToDropdown.vue?vue&type=style&index=0&id=4b63cd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b63cd4e",
  null
  
)

export default component.exports